<div class="wrapper">
  <h1 class="title" *ngIf="!hideH1.includes(slug || '')">
    <img
      *ngIf="slug === 'welcome-user'"
      src="/assets/images/party.svg"
      alt="party icon"
    />

    {{
      slug === 'signup'
        ? 'Join for free'
        : slug === 'add-phone-number'
        ? 'Add your phone number'
        : slug === 'verify-identity'
        ? 'Phone and Email Verification'
        : slug === 'account-setup'
        ? 'Account setup'
        : slug === 'review-cbsa-preferences'
        ? '🌎 We’ve Gone Nationwide!'
        : slug === 'welcome-user' && !!user
        ? 'Welcome, ' + user.firstName + '!'
        : slug === 'forgot-password'
        ? 'Forgot your password?'
        : slug === 'reset-password-sent'
        ? 'Reset password email sent'
        : slug === 'reset-password'
        ? 'Select a New Password'
        : 'Sign in'
    }}
  </h1>
</div>
